import React from 'react';
import { format } from 'date-fns';
import { formatDateKey } from './utils';
import type { DayStatistics } from './types';

type Props = {
  dates: Array<Date>;
  statisticsByDay: Array<DayStatistics>;
  showOnlyLateFilter: boolean;
  onToggleLateFilter: () => void;
};

const WorkSessionsTableHeader = ({ dates, statisticsByDay, showOnlyLateFilter, onToggleLateFilter }: Props): React.ReactElement => (
  <thead>
    <tr>
      <th className="user-column" style={{ textAlign: 'left' }}>
        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', marginLeft: 'auto', cursor: 'pointer', fontWeight: 500, color: '#ffffff' }}>
          Show users with late check-ins
          <input
            type="checkbox"
            checked={showOnlyLateFilter}
            onChange={onToggleLateFilter}
            style={{ width: '16px', height: '16px', cursor: 'pointer' }}
          />
        </label>
      </th>

      {dates.map(dateObj => {
        const isWeekend = dateObj.getDay() === 0 || dateObj.getDay() === 6;
        const headerText = format(dateObj, 'eee dd/MM');
        const dateString = formatDateKey(dateObj);
        const dayStats = statisticsByDay.find(stat => stat.date === dateString);
        const onSiteCount = dayStats ? dayStats.onSiteCount : 0;

        return (
          <th
            key={dateObj.toISOString()}
            className={`day-column${isWeekend ? ' weekend' : ''}`}
            style={{ backgroundColor: isWeekend ? '#f0f0f0' : 'transparent', textAlign: 'center' }}
          >
            {!isWeekend && (
              <div style={{ fontSize: '8px', fontWeight: 'normal', color: '#f0f0f0a9', marginTop: '4px' }}>
                {onSiteCount} on site
              </div>
            )}
            <div>{headerText}</div>
          </th>
        );
      })}
    </tr>
  </thead>
);

export default WorkSessionsTableHeader;
